$(async function () {
  const collectionId = $("#main-collection-brand").data("collection-id");
  const brand = await SixtyPercentApiWebClient.fetchVendorByCollectionId(
    collectionId
  );

  setRelatedArticles(brand);
  setCountryFlag(brand);
});

function searchByBrandTag(sectionId, brandId) {
  let queryString = `tag:brand_${brandId}`;

  fetch(
    ""
      .concat(window.routes.searchUrl, "?section_id=")
      .concat(sectionId, "&type=article&q=")
      .concat(queryString),
    {
      credentials: "same-origin",
      method: "GET",
    }
  ).then(function (response) {
    if (response.status == 200) {
      response.text().then(function (content) {
        let tempElement = document.createElement("div");
        tempElement.innerHTML = content;

        $(`#shopify-section-${sectionId}`).html(tempElement.innerHTML);

        let carousel = $(`#shopify-section-${sectionId}`).find(
          "div[data-slick-target='true']"
        );
        if (carousel.length > 0) {
          carousel.slick(JSON.parse(carousel.data("slick")));
        }
      });
    } else {
      $(`#shopify-section-${sectionId}`).remove();
    }
  });
}

function setRelatedArticles(brand) {
  $(".RelatedArticles").each(function () {
    const sectionId = $(this).data("section-id");

    (brand) => {
      if (brand.id) searchByBrandTag(sectionId, brand.id);
    };
  });
}

function setCountryFlag(brand) {
  if (brand.country != null) {
    const country = brand.country;
    const result = new Intl.DisplayNames(["ja"], { type: "region" });
    countryFlagElement = document.getElementById("brandCollectionCountryFlag");
    countryElement = document.getElementById("brandCollectionCountry");
    const flagClassName = "flag-icon-" + country.toLowerCase();
    countryFlagElement.classList.add(flagClassName);
    countryElement.textContent = result.of(country);
  }
}
